import i18next from 'i18next'
import * as React from 'react'
import type { CommonDeps } from '../base/CommonDeps'
import { SVG_NoConnection } from '../svg/SVG_NoConnection'

interface Props {
    deps: CommonDeps
    onClick: () => void
}

export class NoInternetPage extends React.Component<Props, {}> {
    public render() {
        return (
            <div className="AppCore__ui__NoInternetPage__offline">
                <div className="AppCore__ui__NoInternetPage__offline-image">
                    <SVG_NoConnection />
                </div>
                <div className="AppCore__ui__NoInternetPage__offline-title">
                    {i18next.t('appcore:noInternet.title')}
                </div>
                <div className="AppCore__ui__NoInternetPage__offline-message">
                    {i18next.t('appcore:noInternet.message')}
                </div>
                <div className="AppCore__ui__NoInternetPage__offline-button" onClick={this.props.onClick}>
                    {i18next.t('appcore:noInternet.tryAgain')}
                </div>
            </div>
        )
    }
}
